import { transformActions } from 'utils/';
import { GET_ITEM_HISTORY } from 'actions/types';

const initialState = { data: [], isLoading: false };

/**
 * @description Stores specific inventory logs array details in redux state
 * @returns {[]}
 * @param {[]} state
 * @param {{}} action
 */
export function itemHistory(state = initialState, action) {
  const { type, payload } = action;
  const actions = [GET_ITEM_HISTORY];
  const success = transformActions(actions, 'SUCCESS');
  const failure = transformActions(actions, 'FAILURE');
  if (type === GET_ITEM_HISTORY) {
    return { data: [], isLoading: true };
  }
  if (success.includes(type)) {
    return { data: payload, isLoading: false };
  }
  if (failure.includes(type)) {
    return { data: [], isLoading: false };
  }
  return state;
}
